module.exports = __webpack_public_path__ + "static/media/005.4f638c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/005.jpg
// module id = 512
// module chunks = 0